import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/dailyneedsworld.com/httpdocs/src/app/products/[slug]/ProductDetailClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/dailyneedsworld.com/httpdocs/src/components/common/ProductNotFound.tsx");
